export default __webpack_public_path__ + "static/0275-936717541599dfacefc96b2536bd2dee.png";